import BrandNav from './BrandNav';
import brandLogoSrc from './smartlogo.png';

export { BrandNav, brandLogoSrc };
